export default __webpack_public_path__ + "static/bc_en_5-55a904a42b098880e799826533a8842f.mp4";